var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5797 6.47619L7.76065 10.7302L6.69399 11.619L0.217796 6.28571C0.0781945 6.16703 0 6.00746 0 5.84127C0 5.67508 0.0781945 5.51551 0.217796 5.39683L6.69399 0L7.76065 0.888888L2.5797 5.20635H36.0323V6.47619H2.5797Z"}));
}

ArrowLeft.defaultProps = {"width":"37","height":"12","viewBox":"0 0 37 12"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
